import Observer from '@/common/scripts/observer';
import {Utils} from '@/common/scripts/utils';

const observer = new Observer();

class InitPlanoplan {
    constructor(options) {
        this.elem = options.elem;

        this.popWidget = null;
    }

    init() {
        this.planoplanApi = window.Planoplan;

        // Если скрипт планоплана уже есть на странице, то запускаем загрузку виджета, если нет, подгружаем скрипт
        if (this.planoplanApi) {
            this._load();
        } else {
            Utils.loadScript('https://widget.planoplan.com/etc/multiwidget/release/static/js/main.js', () => {
                this.planoplanApi = window.Planoplan;

                this._load();
            });
        }
    }

    reinit() {
        this.popWidget.reinit({uid: this.elem.dataset.uid});
    }

    _subscribes() {
        observer.subscribe('planoplan:reinit', () => {
            if (!this.planoplanApi) {
                return;
            }

            this.reinit();
        });
    }

    // Загружаем виджет планоплана
    _load() {
        const widgetData = JSON.parse(atob(this.elem.dataset.planoplan));

        const planoplanOptions = {
            el             : this.elem.id,
            uid            : this.elem.dataset.uid,
            primaryColor   : widgetData.primaryColor,
            secondaryColor : widgetData.secondaryColor,
            textColor      : widgetData.textColor,
            backgroundColor: widgetData.backgroundColor
        };

        /* eslint-disable no-undef */
        this.popWidget = this.planoplanApi.init(planoplanOptions);

        this._subscribes();
    }
}

export default InitPlanoplan;
